<template>

<form id="commandTypeForm" class="mx-auto col-sm-8" @submit.prevent>

  <div class="row">
    <div class="form-group col-lg-12" :class="{ 'has-error': errors.has('idCommand') }">
      <label for="idCommand">{{ $t('idCommand') }}</label>
      <input
        type="text"
        id="idCommand"
        name="idCommand"
        class="form-control"
        :placeholder="$t('ph_idCommand')"
        v-model="commandType.idCommand"
        v-validate="'required'"
      >
      <small v-show="errors.has('idCommand')" class="form-text text-muted">
        {{ errors.first('idCommand') }}
      </small>
    </div>

    <div class="form-group col-lg-12" :class="{ 'has-error': errors.has('description') }">
      <label for="description">{{ $t('description') }}</label>
      <input
        type="text"
        id="description"
        name="description"
        class="form-control"
        :placeholder="$t('ph_description')"
        v-model="commandType.description"
        v-validate="'required'"
      >
      <small v-show="errors.has('description')" class="form-text text-muted">
        {{ errors.first('description') }}
      </small>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton @click="onClick">
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div> 

</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: 'CommandTypeForm',
  components: {
    LoaderButton
  },
  props: {
    commandType: {
      type: Object,
      default: () => ({
        id: undefined,
        idCommand: undefined,
        description: '',
      })
    }
  },
  methods: {
    ...mapActions('commandtypes', [
      'create',
      'edit',
      'cleanState'
    ]),

    async onClick (evtClick, doneFn) {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { id } = this.commandType

      const promise = id 
        ? this.edit({ id, data: this.commandType })
        : this.create({ commandType: this.commandType })

      const result = await promise

      if (result) this.$router.push({ name: 'listcommandtypes' })
    }
  },

  destroyed () {
    this.cleanState()
  }
}
</script>